module.exports = __webpack_public_path__ + "img/logo_1535.c617b9f0.svg";